module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "blue"
  }), _c('div', {
    staticClass: "wave light-gold",
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  }), _c('div', {
    staticClass: "wave gold",
    domProps: {
      "innerHTML": _vm._s(_vm.wave)
    }
  }), _c('div', {
    staticClass: "preload-images"
  }, _vm._l((_vm.images), function(image) {
    return _c('img', {
      attrs: {
        "srcset": image.srcSet,
        "src": image.images[2].path
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e8548d40"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Loading.vue
// module id = 434
// module chunks = 1